import { render, staticRenderFns } from "./r-item-merge-mode.vue?vue&type=template&id=0fdd89bf"
import script from "./r-item-merge-mode.vue?vue&type=script&lang=js"
export * from "./r-item-merge-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd89bf')) {
      api.createRecord('0fdd89bf', component.options)
    } else {
      api.reload('0fdd89bf', component.options)
    }
    module.hot.accept("./r-item-merge-mode.vue?vue&type=template&id=0fdd89bf", function () {
      api.rerender('0fdd89bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/merge/r-item-merge-mode.vue"
export default component.exports